import styled from 'styled-components';

export const AimScoresBox = styled.div`
    & * {
        font-size: 14px;
    }
`;

